<template lang="pug">
  #LabelIndex.container-width
    h5.text-center.pt-2 顧客標籤
    .px-3
      b-button(
        variant="primary",
        class="mb-3",
        v-if="nowSelect === 'ba'"
      )
        router-link.text-white(
          :to="{ name: 'sa-label-create' }"
        )
          i.fas.fa-tag.mr-1
          | 新增顧客標籤
      b-card.border-0.mb-2.customerCard.word-break-all(
        bg-variant="light",
        v-for="(tag,index) in tagList",
        :key="tag.id"
      )
        .row
          .col-10.d-flex.align-items-center
            span.mr-3 {{ tag.label }}
            i.fas.fa-user.mr-1.text-danger
            span.text-danger {{ tag.people }}
          .col-2.d-flex.align-items-center.justify-content-end
            label.mb-0.d-flex.flex-row-reverse.position-relative(
              :for="`dropTools_${index}`"
              @click="toolsHandler(index)"
            )
              input.toolsInput.d-none(
                type="checkbox",
                :id="`dropTools_${index}`",
                :name="`dropTools_${index}`",
                :checked="toolsOpen.indexOf(index) !== -1"
              )
              b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button.iconBtn.iconToolsBtn(
                variant="primary"
              )
                i.fas.fa-tools.iconTools
              b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button.iconBtn.position-absolute.iconPushBtn(
                variant="primary",
                @click="pushHandler(tag)"
              )
                i.fas.fa-volume-up.iconPush
              b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button.iconBtn.position-absolute.iconEditBtn(
                variant="primary",
                @click="editHandler(tag)"
              )
                i.fas.fa-pencil-alt.iconEdit
              b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button.iconBtn.position-absolute.iconDeleteBtn(
                variant="primary",
                @click="deleteHandler(tag)"
              )
                i.far.fa-trash-alt.iconDelete
</template>

<script>
import defaultPhotoStickerUrl from '@/assets/images/default/defaultImg404.png';
import { SM_LABEL_EDIT } from '@/router/sm/label';
import { SM_CHAT_ROOM_INDEX } from '@/router/sm/chat-room';

export default {
  name: 'LabelIndex',
  data() {
    return {
      defaultPhotoSticker: `this.src="${defaultPhotoStickerUrl}"`,
      toolsOpen: [],
      tagList: [
        {
          id: 0,
          label: '美白',
          people: 4
        },
        {
          id: 1,
          label: '抗痘',
          people: 12
        },
        {
          id: 2,
          label: '保濕',
          people: 20
        }
      ]
    };
  },
  mounted() {
    this.$store.commit('toggleLoading', false);
  },
  methods: {
    toolsHandler(index) {
      const vm = this;
      if (vm.toolsOpen.indexOf(index) === -1) {
        vm.toolsOpen.push(index);
      } else {
        vm.toolsOpen.splice(vm.toolsOpen.indexOf(index), 1);
      }
    },
    pushHandler(tag) {
      const vm = this;
      console.log('群體推播', tag);
      vm.$router.push({
        name: SM_CHAT_ROOM_INDEX
      });
    },
    editHandler({ id }) {
      const vm = this;
      console.log('編輯', id);
      vm.$router.push({
        name: SM_LABEL_EDIT,
        params: {
          id
        }
      });
    },
    deleteHandler(tag) {
      const vm = this;
      console.log('刪除', tag);
      vm.$swal.fire({
        title: '您確定刪除標籤?',
        text: '刪除後標籤無法復原！',
        html: `請注意，刪除後已經貼標的顧客將失去<span style="color: #d33"> ${tag.label} </span> 標籤`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        reverseButtons: true,
        customClass: {
          confirmButton: 'custom-swal-btn',
          cancelButton: 'custom-swal-btn'
        }
      }).then((result) => {
        if (result.value) {
          vm.$swal.fire({
            title: '標籤刪除中，請稍候',
            allowOutsideClick: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });
          setTimeout(() => {
            vm.$swal.close();
          }, 2000);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>

.iconBtn {
  position: absolute;
  transition: all .3s;
  right: 0;
  width: 40px;
  height: 40px;
}

.iconToolsBtn {
  position: relative;
  z-index: 5;
  transition: all .3s;
  transform: scale(1.1);
}

.toolsInput:checked + .iconToolsBtn {
  transform: scale(1);
}

.toolsInput:checked ~ .iconPushBtn {
  right: 42px;
}

.toolsInput:checked ~ .iconEditBtn {
  right: 84px;
}

.toolsInput:checked ~ .iconDeleteBtn {
  right: 126px;
}
</style>
